module.exports = __webpack_public_path__ + "img/xcx2.cd21098e.jpg";